export const MAP_ICON_URL = {
    CURRENT_LOCATION_ICON: '/assets/svg/current-location-icon.svg',
    DESTINATION_POINT_ICON: '/assets/svg/destination-point-icon.svg',
    POSITION_MARKER_ICON: '/assets/svg/position-marker-icon.svg',
    START_POINT_ICON: '/assets/svg/start-point-icon.svg',
    WALKING_PERSON_ICON: '/assets/svg/walking-person-icon.svg',
};

export const DESTINATION_MARKER_THEME_FALLBACK = {
    DEFAULT: '#1B53E3',
    CONTRAST: '#1B53E3',
} as const;
